import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import {
  Activity,
  Airplay,
  AlertCircle,
  AlertTriangle,
  AlignJustify,
  AlignCenter,
  AlignLeft,
  AlignRight,
  Anchor,
  Archive,
  ArrowDown,
  ArrowDownCircle,
  Crosshair,
  AlertOctagon,
  Repeat,
  ArrowDownLeft,
  ArrowDownRight,
  ArrowLeftCircle,
  ArrowLeft,
  ArrowRight,
  ArrowRightCircle,
  ArrowUp,
  ArrowUpCircle,
  ArrowUpRight,
  AtSign,
  ArrowUpLeft,
  CheckCircle,
  X,
  XCircle,
  MoreVertical,
  Instagram,
  MessageSquare,
  ChevronsLeft,
  ChevronRight,
  FileText,
  Check,
  MoreHorizontal,
  VolumeX,
  Star,
  Edit3,
  File,
  Download,
  CornerDownLeft,
  EyeOff,
  CornerUpRight,
  BarChart2,
  Bell,
  Eye,
  DollarSign,
  CornerDownRight,
  Mail,
  Volume,
  Facebook,
  Calendar,
  Smile,
  Clock,
  Minimize2,
  Maximize2,
  Trash,
  Link2,
  CreditCard,
  User,
  Hash,
  Copy,
  Link,
  Plus,
  Save,
  ShoppingBag,
  Clipboard,
  Smartphone,
  Monitor,
  Search,
  Filter,
  ChevronUp,
  ChevronDown,
  Edit,
  Send,
  Trash2,
  Database,
  RefreshCw,
  Upload,
  Image,
  Folder,
  Camera,
  Video,
  HelpCircle,
  Grid,
  Settings,
  Minus,
  Edit2,
  FileMinus,
  Tag,
  Table,
  MapPin,
  GitBranch,
  Briefcase,
  RotateCcw,
  LogOut,
  Book,
  MessageCircle,
  Paperclip,
  Volume2,
  Phone,
  ChevronsRight,
  ChevronLeft,
  Server,
  Percent,
  FilePlus,
  TrendingUp,
  PlusCircle,
  Shuffle,
  Heart,
  Info,
  ThumbsUp,
  Pause,
  ExternalLink,
  
  
} from 'angular-feather/icons';
const icons = {
  Settings,
  Pause,
  Paperclip,
  MessageCircle,
  Book,
  LogOut,
  ChevronUp,
  Database,
  Send,
  ChevronDown,
  Activity,
  Airplay,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  Anchor,
  Archive,
  ArrowDown,
  ArrowDownCircle,
  ArrowDownLeft,
  ArrowDownRight,
  ArrowLeft,
  ArrowLeftCircle,
  ArrowRight,
  ArrowRightCircle,
  ArrowUp,
  ArrowUpCircle,
  ArrowUpLeft,
  ArrowUpRight,
  AtSign,
  Repeat,
  Crosshair,
  CheckCircle,
  X,
  XCircle,
  MoreVertical,
  Instagram,
  MessageSquare,
  Copy,
  ChevronsLeft,
  ChevronLeft,
  ChevronRight,
  DollarSign,
  FileText,
  Check,
  MoreHorizontal,
  Trash2,
  VolumeX,
  Star,
  Edit3,
  File,
  Download,
  CornerDownLeft,
  EyeOff,
  CornerUpRight,
  BarChart2,
  Bell,
  Eye,
  Calendar,
  Smile,
  Clock,
  CornerDownRight,
  Mail,
  Volume,
  Facebook,
  Minimize2,
  Hash,
  Maximize2,
  Trash,
  Link2,
  CreditCard,
  User,
  Link,
  Plus,
  Save,
  ShoppingBag,
  Clipboard,
  Smartphone,
  Monitor,
  Search,
  Filter,
  Edit,
  RefreshCw,
  Upload,
  Image,
  Folder,
  Camera,
  Video,
  HelpCircle,
  Grid,
  Minus,
  Edit2,
  FileMinus,
  Tag,
  Table,
  MapPin,
  GitBranch,
  Briefcase,
  RotateCcw,
  Volume2,
  Server,
  Percent,
  ChevronsRight,
  Phone,
  FilePlus,
  TrendingUp,
  PlusCircle,
  Shuffle,
  Heart,
  Info,
  ThumbsUp,
  ExternalLink
};

@NgModule({
  declarations: [],
  imports: [CommonModule, FeatherModule.pick(icons)],
  exports: [FeatherModule],
})
export class IconsModule { }
